
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import LanguageIcon from '@mui/icons-material/Language';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import UpdateIcon from '@mui/icons-material/Update';
import CelebrationIcon from '@mui/icons-material/Celebration';
import ShopIcon from '@mui/icons-material/Shop';
import TtkList from './TtkList';
const GroomWearTTK = ({ data }) => {
    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <div className='row mb-2'>
                        <div className='col-md-3'>
                            <p> <WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working Since :</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p ><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b> Starting Price :</b>&nbsp;<span>&#8377; {data?.startingPrice}</span></p>
                        </div>
                        <div className='col-md-3'>
                            <p ><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b> Sherwani Price :</b>&nbsp;<span>&#8377; {data?.sherwaniPrice}</span></p>
                        </div>
                        <div className='col-md-3'>
                            <p> <ShopIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Store Type :</b>&nbsp;<TtkList data={data?.storeTypeGroom} /></p>
                        </div>

                    </div>
                    <div className='row mb-2'>
                        <div className='col-md-6'>
                            <p> <CelebrationIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Services Offered :</b>&nbsp;<TtkList data={data?.serviceOfferedGroom} /></p>
                        </div>
                        <div className='col-md-6'>
                            <p> <UpdateIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Delivery Date :</b>&nbsp;<TtkList data={data?.deliveryDate} /></p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default GroomWearTTK